// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconDashboard = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 16 16' ref={ref} {...props}>
        <mask
            id='icon-dashboard_svg__a'
            width={14}
            height={14}
            x={1}
            y={1}
            maskUnits='userSpaceOnUse'
            style={{
                maskType: 'alpha',
            }}
        >
            <path
                fill='#fff'
                fillRule='evenodd'
                d='M1.6 3.1a1.5 1.5 0 0 1 1.5-1.5h9.8a1.5 1.5 0 0 1 1.5 1.5v.2a1.5 1.5 0 0 1-1.5 1.5H3.1a1.5 1.5 0 0 1-1.5-1.5zm0 4.8a1.5 1.5 0 0 1 1.5-1.5h.2a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5h-.2a1.5 1.5 0 0 1-1.5-1.5zm6.3-1.5a1.5 1.5 0 0 0-1.5 1.5v5a1.5 1.5 0 0 0 1.5 1.5h5a1.5 1.5 0 0 0 1.5-1.5v-5a1.5 1.5 0 0 0-1.5-1.5z'
                clipRule='evenodd'
            />
        </mask>
        <g mask='url(#icon-dashboard_svg__a)'>
            <path fill='currentcolor' d='M0 0h16v16H0z' />
        </g>
    </svg>
)
const ForwardRef = forwardRef(SvgIconDashboard)
const Memo = memo(ForwardRef)
export default Memo
